import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as endpoints from '../../../helpers/endpoints';

class Utilities extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deleteConfirmation: false
        };
    }

    handleDelete(that) {
        let confirmDialog = window.confirm(
            'Are you sure you wish to delete this event?'
        );
        if (confirmDialog === true) {
            that.props.deleteEvent();
        }
    }

    render() {
        const that = this;
        return (
            <div className="event__utilities">
                {this.props.download ? (
                    <a
                        href={`${endpoints.EVENT_ADREQUEST_PATH}?id=${this.props
                            .eventId}&t=${this.props.jwtToken}`}
                        target="_blank"
                        title="Download Ad Request"
                        className="event__utility"
                    >
                        Download Ad Request
                    </a>
                ) : (
                    ''
                )}

                {this.props.print ? (
                    <a
                        href={`${endpoints.AFTER_ACTION_SUMMARY_PATH}?id=${this
                            .props.eventId}&t=${this.props.jwtToken}`}
                        title="Print After Action"
                        className="event__utility"
                        target="_blank"
                    >
                        Print After Action
                    </a>
                ) : (
                    ''
                )}

                {this.props.delete ? (
                    <Link
                        to="#"
                        className="event__delete event__utility"
                        onClick={() => {
                            this.handleDelete(that);
                        }}
                    >
                        Delete Event
                    </Link>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default Utilities;



// WEBPACK FOOTER //
// ./src/components/event/utilities/index.js